import { render, staticRenderFns } from "./GroupsTreeChildren.vue?vue&type=template&id=114481cc&scoped=true&"
import script from "./GroupsTreeChildren.vue?vue&type=script&lang=js&"
export * from "./GroupsTreeChildren.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTreeChildren.vue?vue&type=style&index=0&id=114481cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114481cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
